import Vue from 'vue';
import da from 'vee-validate/dist/locale/da';
import en from 'vee-validate/dist/locale/en';
import VeeValidate, {
    Validator
} from 'vee-validate';
import { translations } from '../utils/translations';

Vue.use(VeeValidate, {
    behavior: 'eager'
  });

const dictEn = {
  ...en,
  custom: {
      cellularPhone: {
          required: () => translations.en.contactForm.validationMessage.phoneNumberRequired,
      },
  }
};

const dictDa = {
  ...da,
  custom: {
      cellularPhone: {
          required: () => translations.da.contactForm.validationMessage.phoneNumberRequired,
      },
  }
};

Validator.localize('en', dictEn);
Validator.localize('da', dictDa);